import { render } from "./PackageEditing.vue?vue&type=template&id=2e1b4077&ts=true"
import script from "./PackageEditing.vue?vue&type=script&lang=ts"
export * from "./PackageEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__